import ModelUpdate from "@/models/ModelUpdate";
import {ValidationRule} from "@/declarations/ValidationRule";
import ShipmentTypeRules from "@/models/shipment-type/ShipmentTypeRules";
import TranslatedValueUpdate from "@/models/translated-value/TranslatedValueUpdate";
import {IShipmentTypeAdmin} from "@/models/shipment-type/ShipmentTypeAdminModels";
import {DeliveryMethod} from "@/helpers/constants";
import PostageBulkPriceUpdate from "@/models/shipment-type/PostageBulkPriceUpdate";
import {IPostageBulkPriceUpdate} from "@/models/shipment-type/PostageBulkPriceAdminModels";

export default class ShipmentTypeUpdate extends ModelUpdate<IShipmentTypeAdmin> {

	public name!: TranslatedValueUpdate;
	public francoLimit!: number | null;
	public postageBulkPrices!: IPostageBulkPriceUpdate[];
	public externalId!: string | null;
	public isBulkyGoodsCharged: boolean = false;
	public deliveryMethod!: DeliveryMethod

	public constructor(model: IShipmentTypeAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IShipmentTypeAdmin): void {
		this.name = new TranslatedValueUpdate(detailModel.name);
		this.francoLimit = detailModel.francoLimit?.amount ?? null;
		this.postageBulkPrices = detailModel.postageBulkPrices.map(pbp => {
			return new PostageBulkPriceUpdate(pbp);
		});
		this.externalId = detailModel.externalId;
		this.deliveryMethod = detailModel.deliveryMethod;
		this.isBulkyGoodsCharged = detailModel.isBulkyGoodsCharged;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'deliveryMethod':
				return ShipmentTypeRules.deliveryMethod;
			default:
				return [];
		}
	}

}
